import { projects } from "../data/site";
import Contact from "./Contact";
import Nav from "./Nav";
import ProjectCard from "./ProjectCard";
import Reveal from "./Reveal";

const ProjectsPage = () => {
  const p = projects;
  return (
    <>
      <Nav />
      <main>
        <header className="page-head">
          <div className="wrap">
            <a className="page-back" href="/" onClick={(e) => {
              e.preventDefault();
              const site = document.querySelector(".site");
              const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
              if (!site || reduce) { window.location.href = "/"; return; }
              site.classList.remove("fx-in");
              site.classList.add("fx-out");
              setTimeout(() => { window.location.href = "/"; }, 300);
            }}>← Back home</a>
            <div className="sec-eyebrow">
              <span className="sec-num">✦</span>
              <span className="sec-kicker">Selected work</span>
            </div>
            <h1 className="page-title">{p.title}</h1>
            <p className="page-lead">
              {p.description} Each one is open-source — click through to the live build or the code.
            </p>
          </div>
        </header>
        <section className="section projects-page">
          <div className="proj-grid">
            {p.items.map((proj, i) => (
              <Reveal key={proj.id} delay={(i % 2) * 80}>
                <ProjectCard proj={proj} />
              </Reveal>
            ))}
          </div>
        </section>
        <Contact />
      </main>
    </>
  );
};

export default ProjectsPage;
